<template>
    <div class="content-wrapper">
        <div class="content">
            <div class="container-fluid">
                 <div style="text-align: center;"><h1>Error</h1>
                <a href="#" >
                    <img src="../../src/assets/AccessDeniedError.png" alt="AccessDenied" />
                </a>
            </div>
            </div>
        </div>
    </div>
</template>
